import Divided from "components/organisms/common/Divided"

export function Curicculum({ image, title, theme = "light", children }) {
  return (
    <Divided
      Image={image}
      title={title}
      theme={theme}
      reversed
      noVerticalPadding
      className="my-16 lg:my-24"
      fullHeight
    >
      {children}
    </Divided>
  )
}
